import axios from "axios";
import moment from "moment";
import store from "@/store";
let config = {
  baseURL: store.getters.server
}
const instance = axios.create(config);

export default {
  async getUsuarios() {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.get("/users/getall", headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },
  async getUsuariosId(id) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.get("/users/getallid/"+id, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },
  async getFuncionarios() {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.get("/users/getFuncionarios", headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },
  async getLogs () {
    try {
      let response = await instance.get('/logs/get');
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },

  async getUsuario(id) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.get("/users/id/" + id, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },

  async saveUsuario(user) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance
        .post("/users/register", {
          name: user.name,
          email: user.username,
          password: user.senha,
          acesso: user.acesso,
          cliente: user.cliente,
          devedor: user.devedor
        }, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },

  async saveUsuarioDevedor(user) {
    try {
      let response = await instance
        .post("/users/registerDevedor", {
          name: user.name,
          email: user.username,
          password: user.senha,
          acesso: user.acesso,
          cliente: user.cliente,
          devedor: user.devedor
        });
      return response.data;
    } catch (err) {
      console.log((err));
      store.dispatch('setError', err.response.data.message);
    }
  },
  
  async saveUsuarioSenha(user) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance
        .post("/users/pass", {
          id: user._id,
          name: user.name,
          email: user.username,
          password: user.senha,
          acesso: user.acesso,
          cliente: user.cliente,
          devedor: user.devedor
        }, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  },
  async alterarUsuario(id, user) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.put("/users/alterar/" + id, user, headers);
      return response.data;
    } catch (err) {
      console.log(err.response);
      store.dispatch('setError', err.response.data.message);
    }
  },

  async deleteUser(id) {
    try {
      let headers = { headers: { "x-access-token": localStorage.getItem("cobranca-token") }};
      let response = await instance.delete("/users/remove/" + id, headers);
      return response.data;
    } catch (err) {
      console.log((err.response));
      store.dispatch('setError', err.response.data.message);
    }
  }
};



// WEBPACK FOOTER //
// ./src/services/usuario.js